import {
  GET_INVESTORS_LIST_SUCCESS,
  YES,
  GET_INVESTOR_DETAILS_SUCCESS,
  PANALL,
  FAVOURITE_INVESTOR_SUCCESS,
  GET_INVESTORS_LIST,
  SEARCH_INVESTORS_SUCCESS,
  SEARCH_INVESTORS,
  GET_INVESTOR_DETAILS,
  GET_UPCOMING_SIP_DETAILS_SUCCESS,
  ALL,
  STORE_TYPE,
  STORE_KYC_DATA,
} from "../types";

const initialState = {
  investors: [],
  count: 0,
  investments: [],
  upComingSipDetails: [],
  selectedTab: ALL,
  kycData: {},
};

export function investor(state = initialState, action) {
  switch (action.type) {
    case GET_INVESTORS_LIST_SUCCESS: {
      let { DtData } = action.body;
      DtData = DtData?.map((investor) => ({
        ...investor,
        Kyc: investor.Kyc === YES,
        Fatca: investor.Fatca === YES,
      }));
      return {
        ...state,
        investors: DtData,
        count: DtData.length,
      };
    }
    case SEARCH_INVESTORS:{
      return{
        ...state,
        investors:[],
      }
    }
    case GET_INVESTORS_LIST: {
      return { ...state, investors: [] };
    }
    case GET_INVESTOR_DETAILS: {
      return {
        ...state,
        investorData: {},
        showAll: false,
        fundAllocation: [],
        pieData: [],
        investments: [],
        communicationDetails: [],
        investorInvestmentDetails: [],
        fundLevelInvestments: [],
      };
    }
    case GET_INVESTOR_DETAILS_SUCCESS: {
      const {
        Table14: communicationDetails,
        Table3,
        Table5: investorInvestmentDetails,
        Table11,
        Table12: fundLevelInvestments,
        Table13: investments,
      } = action.body;
      const asOnDate = action.body.Dtinformation[0].asondate;
      const { investors = [] } = state;
      const [investorData] = Table11;
      const fav = investors.find((inv) => inv.Pan === investorData.PAN) || {};
      const fundAllocation = Table3.filter((fund) => fund.PAN === PANALL);
      const pieData = fundAllocation.map((item) => ({
        name: item.name,
        value: item.totpercent,
      }));
      const investorTotal = investorInvestmentDetails.find(
        (x) => x.FundDesc === "Total" && x.PAN === "ALL"
      );
      return {
        ...state,
        investorData: { ...investorData, fav: fav.Favorite },
        fundAllocation,
        pieData,
        investorTotal,
        asOnDate,
        investments,
        communicationDetails,
        fundLevelInvestments,
      };
    }
    case FAVOURITE_INVESTOR_SUCCESS: {
      const { InvPan, FavFlag } = action.data;
      let { investors, investorData } = state;
      investors = investors.map((inv) => ({
        ...inv,
        Favorite: inv.Pan === InvPan ? FavFlag : inv.Favorite,
      }));
      return {
        ...state,
        investors,
        investorData: { ...investorData, fav: FavFlag },
      };
    }
    case SEARCH_INVESTORS_SUCCESS: {
      const { Dtdata } = action.body;
      return { ...state, investors: Dtdata };
    }
    case GET_UPCOMING_SIP_DETAILS_SUCCESS: {
      const { DtData } = action.body;
      return { ...state, upComingSipDetails: DtData };
    }
    case STORE_KYC_DATA: {
      return { ...state, kycData: action.body };
    }
    case STORE_TYPE: {
      const { selectedTab } = action.body;
      return { ...state, selectedTab };
    }
    default:
      return state;
  }
}
